import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import DeleteFilledIcon from '../../core-components/assets/icons/DeleteIconFilled';
import EditIcon from '../../core-components/assets/icons/EditIcon';
import { Neutrals } from '../../core-components/theme/color-palette/colors';
import CustomIconButton from '../../core-components/theme/components/Button/Iconbutton';
import useFetchPermission from '../../utilities/customHooks/useFetchPermission';

export default function TableActions({
    rowData,
    DeleteComponent,
    EditComponent,
    deleteAction,
    deletePermission,
    editAction,
    customMenuItems,
    disabled,
    children
}: any) {
    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedAction, setSelectedAction] = useState<null | string>(null);
    const isDeleteAuthorized = useFetchPermission(deletePermission);
    const openMenu = (event: React.MouseEvent<HTMLElement>) => {
        if (disabled) return;
        event?.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
    };

    const closeMenu = (event: React.MouseEvent<HTMLElement>) => {
        event?.stopPropagation();
        setMenuAnchorEl(null);
    };

    function handleCloseModal(event: React.MouseEvent<HTMLElement>) {
        event?.stopPropagation();
        setSelectedAction(null);
    }

    function handleDelete(event: React.MouseEvent<HTMLElement>) {
        event?.stopPropagation();
        if (deleteAction) deleteAction(rowData);
        else setSelectedAction('delete');
        closeMenu(event);
    }

    function handleEdit(event: React.MouseEvent<HTMLElement>) {
        event?.stopPropagation();
        if (editAction) editAction(rowData);
        else setSelectedAction('edit');
        closeMenu(event);
    }

    return (
        <React.Fragment>
            <CustomIconButton onClick={openMenu} icon={MoreVertIcon} disabled={disabled} />
            <Menu
                anchorEl={menuAnchorEl}
                open={!!menuAnchorEl}
                onClose={closeMenu}
                slotProps={{
                    paper: {
                        style: {
                            boxShadow: '0px 2px 8px 0px #1A335626',
                        },
                    },
                }}
                MenuListProps={{
                    sx: {
                        border: `1px solid ${Neutrals[300]}`,
                        py: 0,
                        backgroundColor: '#ffffff',
                        borderRadius: '4px',
                    },
                }}
            >
                {(EditComponent || editAction) && (
                    <MenuItem
                        sx={{ height: '36px', paddingLeft: '8px', borderBottom: `1px solid ${Neutrals[300]}` }}
                        onClick={handleEdit}
                    >
                        <EditIcon />
                        <Typography ml={2} color={Neutrals[500]}>
                            Edit
                        </Typography>
                    </MenuItem>
                )}
                {(DeleteComponent || deleteAction) && (!!deletePermission ? isDeleteAuthorized : true) && (
                    <MenuItem onClick={handleDelete} sx={{ height: '36px', paddingLeft: '8px' }}>
                        <DeleteFilledIcon />
                        <Typography ml={2} color={Neutrals[500]}>
                            Delete
                        </Typography>
                    </MenuItem>
                )}
                {customMenuItems && customMenuItems.map((item: any) => item)}
                {children}
            </Menu>
            {selectedAction === 'edit' && EditComponent && (
                    <EditComponent data={rowData} handleClose={handleCloseModal} />
            )}
            {selectedAction === 'delete' && DeleteComponent && (
                <div onClick={(e) => e.stopPropagation()}>
                    <DeleteComponent data={rowData} handleClose={handleCloseModal} />
                </div>
            )}
        </React.Fragment>
    );
}
